import React, { useEffect, useState, useRef } from "react";
import styled, { keyframes, css } from "styled-components";
import { useHistory } from "react-router-dom";
import {
  LuAlignHorizontalJustifyCenter,
  LuCalendarClock,
  LuSendHorizontal,
  LuKeyboard,
  LuRefreshCw,
} from "react-icons/lu";
import { GrServices } from "react-icons/gr";
import { TbClock24, TbClockCheck } from "react-icons/tb";
import {
  MdApproval,
  MdDeleteOutline,
  MdOutlineFormatSize,
  MdOutlineTipsAndUpdates,
} from "react-icons/md";
import Testimonial from "../components/Sections/Testimonial";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { animateScroll as scroll } from "react-scroll";
import axios from "axios";
import { HashLoader } from "react-spinners";
import "react-circular-progressbar/dist/styles.css";
import { GoCodescanCheckmark } from "react-icons/go";
import { RiFlowChart, RiRobot2Line } from "react-icons/ri";
import { FaRegFilePdf } from "react-icons/fa6";
import Swal from "sweetalert2";
import { ErrorAlert } from "../components/Elements/SweetAlerts";

let jobDesc1 =
  "Key Responsibilities: Develop and enhance user-facing features using JavaScript, HTML5, and CSS3. Build reusable code and libraries for future use. Ensure technical feasibility of UI/UX designs. Optimize applications for maximum speed and scalability. Validate user input before submitting to back-end services. Collaborate with back-end developers and designers. Debug, test, and maintain existing projects. Integrate third-party services and APIs as needed. Required Skills & Qualifications: Proficient in core JavaScript (ES6+), including asynchronous programming and DOM manipulation. Experience with at least one modern JavaScript framework (e.g., React, Angular, Vue.js). Familiarity with AJAX, JSON, and RESTful APIs. Understanding of cross-browser compatibility issues and solutions. Experience with version control systems (e.g., Git). Basic understanding of front-end build tools (e.g., Webpack, Gulp). Bachelor’s degree in Computer Science or related field preferred.";
let jobDesc2 =
  "Key Responsibilities: Write clean, efficient, and reusable Python code. Develop server-side logic and integrate user-facing elements with server-side logic. Build and maintain web applications using frameworks like Django or Flask. Integrate data storage solutions (e.g., MySQL, PostgreSQL). Test and debug applications to ensure high performance and reliability. Collaborate with front-end developers and other team members. Maintain technical documentation and participate in code reviews. Stay updated with latest Python technologies and best practices. Required Skills & Qualifications: Strong proficiency in Python and understanding of OOP concepts. Experience with at least one Python web framework (Django, Flask, etc.). Familiarity with relational databases and ORM libraries. Basic knowledge of front-end technologies (HTML, CSS, JavaScript). Experience with version control systems (Git). Good problem-solving and communication skills. Bachelor’s degree in Computer Science or related field preferred.";
let jobDesc3 =
  "Key Responsibilities: Develop, test, and maintain web applications using PHP. Write clean, scalable, and well-documented code. Collaborate with front-end developers to integrate user-facing elements. Troubleshoot, debug, and optimize existing applications. Work with databases (e.g., MySQL), and manage data exchange between server and users. Participate in code reviews and contribute to best practices]. Stay updated with emerging technologies and apply them to ongoing projects. Required Skills & Qualifications: Proficient in PHP and understanding of OOP principles. Experience with PHP frameworks (e.g., Laravel, CodeIgniter). Familiarity with front-end technologies (HTML, CSS, JavaScript). Understanding of SQL and relational databases. Experience with version control systems (Git). Strong problem-solving skills and attention to detail. Bachelor’s degree in Computer Science or related field preferred.";

let demoUrl =
  "https://writing.colostate.edu/guides/documents/resume/functionalsample.pdf";

const ResumeAnalyseChatBotAgent = () => {
  const history = useHistory();
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const [tryResumeName, setTryResumeName] = useState("");
  const [refreshRotating, setRefreshRotating] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const [requestToken, setRequestToken] = useState("");
  const [requestTokenValidate, setRequestTokenValidate] = useState("");
  console.log(
    "🚀 ~ ResumeAnalyseChatBotAgent.jsx:51 ~ ResumeAnalyseChatBotAgent ~ requestToken:",
    requestToken
  );
  const [isActiveSession, setIsActiveSession] = useState(false);

  // ATS Result
  const [loading, setLoading] = useState(false);

  const initialValues = {
    job_requirements: "",
    resume_file: [],
  };

  // Generate a UUID v4
  function generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  useEffect(() => {
    scroll.scrollToTop();
    const requestId = generateUUID();
    setRequestToken(requestId);
  }, []);

  /**
   * Validation schema for the form using Yup
   * - Job description is required and must be at least 50 characters
   * - Resume file is required and must be PDF, DOC, or DOCX format
   */
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const validationSchema = Yup.object({
    resume_file: Yup.mixed()
      .test("fileFormat", "Only PDF files are allowed", (value) => {
        if (!value) return true;

        const files = fileInputRef?.current?.files;
        if (!files) return true;

        const fileArray = Array.from(files);
        return fileArray.every((file) => file.type === "application/pdf");
      })
      .test("fileCount", "Maximum 10 files allowed", (value) => {
        if (!value) return true;

        const currentFileCount = uploadedFiles.length;
        const newFileCount = fileInputRef?.current?.files?.length || 0;

        return currentFileCount + newFileCount <= 10;
      })
      .test("fileSize", "File size must be less than 3MB", (value) => {
        if (!value) return true;

        const files = fileInputRef?.current?.files;
        if (!files) return true;

        const fileArray = Array.from(files);
        return fileArray.every((file) => file.size <= 3 * 1024 * 1024);
      }),
  });

  const handleDelete = (index, setFieldValue) => {
    // console.log("🚀 ~ ResumeAnalyseChatBotAgent.jsx:98 ~ handleDelete ~ id:", id);
    // setUploadedFiles((prev) => prev.filter((file) => file.id !== id));
    const updatedFiles = [...uploadedFiles];
    updatedFiles.splice(index, 1);
    setUploadedFiles(updatedFiles);
    setFieldValue("resume_file", updatedFiles);
  };

  const handleFileChange = (event, setFieldValue) => {
    const newFiles = Array.from(event.currentTarget.files);

    // Filter out non-PDF files
    const pdfFiles = newFiles.filter((file) => file.type === "application/pdf");

    // Check if adding these files would exceed 10 files
    if (uploadedFiles.length + pdfFiles.length > 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You can only upload a maximum of 10 files.",
      });
      return;
    }

    // Add new files to the existing list
    const updatedFiles = [...uploadedFiles, ...pdfFiles];
    setUploadedFiles(updatedFiles);
    setFieldValue("resume_file", updatedFiles);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleRefresh = ({ setFieldValue }) => {
    setRefreshRotating(true);
    setInput("");
    setMessages([]);
    setFieldValue("job_requirements", "");
    setFieldValue("resume_file", []);
    setUploadedFiles([]);

    // Token handle
    const requestId = generateUUID();
    setRequestToken(requestId);
    setRequestTokenValidate("");
    setIsActiveSession(false);
  };

  const handleSend = async (input) => {
    if (!input.trim()) return;

    // Add user message to chat
    setMessages([...messages, { from: "user", text: input }]);
    setInput("");
    setLoading(true);

    // Simulate API call with setTimeout
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { from: "bot", text: "This is a dummy response." },
      ]);
      setLoading(false);
    }, 1500);
  };

  const handleSubmit = (values, { setSubmitting }) => {
    if (!input.trim()) return;
    console.log("Form submitted with values:", values);
    // Add user message to chat
    setMessages([...messages, { from: "user", text: input }]);
    setInput("");
    setLoading(true);

    const formData = new FormData();

    if (requestToken !== requestTokenValidate) {
      if (values.resume_file) {
        values.resume_file.map((item, index) => {
          formData.append(`resume_file${index}`, item);
        });
      } else {
        if (uploadedFiles?.length > 0) {
          uploadedFiles.map((item, index) => {
            formData.append(`resume_download_url${index}`, item);
          });
        }
      }
      formData.append("job_requirements", values.job_requirements);
    }
    formData.append("prompt", input);
    formData.append("sessionId", requestToken);
    formData.append("type", "text");

    setTimeout(async () => {
      try {
        const response = await axios.post(
          "https://test.ct-n8n.ctserver.space/webhook/225578a4-4b53-4a04-ba08-fe9a8f638794",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(
          "🚀 ~ ResumeAnalyseChatBotAgent.jsx:209 ~ setTimeout ~ response:",
          response
        );
        if (response.data) {
          console.log(
            "🚀 ~ ResumeAnalyseChatBotAgent.jsx:220 ~ setTimeout ~ response.data[0].result:",
            response.data[0].result
          );
          let mesaage = response.data[0].result;
          console.log(
            "🚀 ~ ResumeAnalyseChatBotAgent.jsx:220 ~ setTimeout ~ mesaage:",
            mesaage
          );
          setMessages((prev) => [...prev, { from: "bot", text: mesaage }]);
        }

        if (response.data[0].sessionId) {
          setRequestTokenValidate(response.data[0].sessionId);
        }

        if (response.data[0].sessionId === requestToken) {
          setIsActiveSession(true);
        }

        setSubmitting(false);
        setLoading(false);
      } catch (error) {
        console.error("Error uploading:", error);
        ErrorAlert();
        setLoading(false);
      }
    }, 1000);
  };

  const handleTryJobDesc = (count, setFieldValue) => {
    if (count === "try-1") setFieldValue("job_requirements", jobDesc1);
    if (count === "try-2") setFieldValue("job_requirements", jobDesc2);
    if (count === "try-3") setFieldValue("job_requirements", jobDesc3);
  };

  const handleTryResume = (resumeUrl) => {
    // setTryResumeName(demoUrl.split("/").pop());
    // Check if adding these files would exceed 10 files
    let url = [{ url: demoUrl, name: demoUrl.split("/").pop() }];

    if (uploadedFiles.length + url.length > 10) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You can only upload a maximum of 10 files.",
      });
      return;
    }

    // Add new URL to the existing list
    const updatedFiles = [...uploadedFiles, ...url];
    setUploadedFiles(updatedFiles);
  };

  const handleViewResume = (resumeNumber) => {
    console.log(`Viewing sample resume ${resumeNumber}`);
    // Implementation for viewing sample resume
  };

  return (
    <>
      <Wrapper className="flexNullCenter flexColumn">
        <HeroContainer>
          <ContentWrapper>
            <TextContent>
              <Title>Resume ATS Score Analyzer</Title>
              <Description>
                Instantly evaluate your resume's compatibility with Applicant
                Tracking Systems. Our AI-powered tool analyzes your resume
                against job descriptions to maximize your chances of getting
                past automated screening systems and into the hands of
                recruiters.
              </Description>
            </TextContent>
          </ContentWrapper>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              setFieldValue,
              setFieldTouched,
            }) => (
              <Form style={{ width: "100%" }}>
                <DemoWrapper>
                  <DemoDiv>
                    <ResumeSectionDiv>
                      <StyledForm>
                        <HiddenFileInput
                          type="file"
                          name="resume_file"
                          id="resume_file"
                          ref={fileInputRef}
                          accept=".pdf"
                          multiple
                          onChange={(event) =>
                            handleFileChange(event, setFieldValue)
                          }
                        />

                        <UploadButton
                          type="button"
                          disabled={isActiveSession}
                          onClick={handleUploadClick}
                        >
                          Upload Resume
                        </UploadButton>

                        {errors.resume_file && touched.resume_file ? (
                          <ErrorMessage>{errors.resume_file}</ErrorMessage>
                        ) : null}

                        {uploadedFiles.length > 0 && (
                          <FileListContainer>
                            <FileListTitle>
                              Uploaded Resumes ({uploadedFiles.length}/10)
                            </FileListTitle>
                            <FileList>
                              {uploadedFiles.map((file, index) => (
                                <FileItem key={index}>
                                  <FileIcon>
                                    <FaRegFilePdf />
                                  </FileIcon>
                                  <FileName>{file.name}</FileName>
                                  <DeleteButton
                                    type="button"
                                    disabled={isActiveSession}
                                    onClick={() =>
                                      handleDelete(index, setFieldValue)
                                    }
                                  >
                                    <MdDeleteOutline />
                                  </DeleteButton>
                                </FileItem>
                              ))}
                            </FileList>
                          </FileListContainer>
                        )}

                        <ResumeOptionDiv>
                          <p>No Resumes? Try one of these:</p>

                          <ResumeOptionsContainer>
                            <ResumeOption>
                              <ResumeTitle>Resume 1</ResumeTitle>
                              <ButtonContainer>
                                <TryButton
                                  type="button"
                                  onClick={() => handleTryResume(1)}
                                >
                                  Try it
                                </TryButton>
                                {/* <ViewButton onClick={() => handleViewResume(1)}>
                                View
                              </ViewButton> */}
                              </ButtonContainer>
                            </ResumeOption>

                            <ResumeOption>
                              <ResumeTitle>Resume 2</ResumeTitle>
                              <ButtonContainer>
                                <TryButton
                                  type="button"
                                  onClick={() => handleTryResume(2)}
                                >
                                  Try it
                                </TryButton>
                                {/* <ViewButton onClick={() => handleViewResume(2)}>
                                View
                              </ViewButton> */}
                              </ButtonContainer>
                            </ResumeOption>

                            <ResumeOption>
                              <ResumeTitle>Resume 3</ResumeTitle>
                              <ButtonContainer>
                                <TryButton
                                  type="button"
                                  onClick={() => handleTryResume(3)}
                                >
                                  Try it
                                </TryButton>
                                {/* <ViewButton onClick={() => handleViewResume(3)}>
                                View
                              </ViewButton> */}
                              </ButtonContainer>
                            </ResumeOption>
                          </ResumeOptionsContainer>
                        </ResumeOptionDiv>
                      </StyledForm>
                    </ResumeSectionDiv>
                    <DescSectionDiv>
                      <CardTitle>Job Description *</CardTitle>
                      <TextAreaWrapper>
                        <ErrorMessageStyled
                          name="job_requirements"
                          component="div"
                        />
                        <Field
                          as={StyledTextArea}
                          disabled={isActiveSession}
                          name="job_requirements"
                          placeholder="Write your job description here..."
                        />
                      </TextAreaWrapper>
                      <ResumeOptionDiv>
                        <p>Try one of these job description:</p>

                        <ResumeOptionsContainer>
                          <ResumeOption>
                            <ResumeTitle>Sample 1</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() =>
                                  handleTryJobDesc("try-1", setFieldValue)
                                }
                              >
                                Try it
                              </TryButton>
                            </ButtonContainer>
                          </ResumeOption>

                          <ResumeOption>
                            <ResumeTitle>Sample 2</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() =>
                                  handleTryJobDesc("try-2", setFieldValue)
                                }
                              >
                                Try it
                              </TryButton>
                            </ButtonContainer>
                          </ResumeOption>

                          <ResumeOption>
                            <ResumeTitle>Sample 3</ResumeTitle>
                            <ButtonContainer>
                              <TryButton
                                type="button"
                                onClick={() =>
                                  handleTryJobDesc("try-3", setFieldValue)
                                }
                              >
                                Try it
                              </TryButton>
                            </ButtonContainer>
                          </ResumeOption>
                        </ResumeOptionsContainer>
                      </ResumeOptionDiv>
                    </DescSectionDiv>
                  </DemoDiv>

                  {/* <SubmitButtonWrapper>
                    <SubmitButton type="submit" disabled={loading}>
                      {loading ? "Analyzing..." : "Analyze Resume"}
                    </SubmitButton>
                  </SubmitButtonWrapper> */}

                  <div style={{ padding: "20px 0px" }}>
                    <ChatPreview>
                      <ChatWindow>
                        <ChatHeader>
                          <BotInfo>
                            <RiRobot2Line fontSize={24} />
                            <BotName>Chatbot</BotName>
                          </BotInfo>
                          <RefreshIcon
                            onClick={() => handleRefresh({ setFieldValue })}
                            rotating={refreshRotating}
                            onAnimationEnd={() => setRefreshRotating(false)}
                          >
                            <LuRefreshCw fontSize={22} />
                          </RefreshIcon>
                        </ChatHeader>
                        <ChatBody>
                          {messages.length === 0 && (
                            <ChatMessage>
                              ---- Chat start here. ----
                            </ChatMessage>
                          )}

                          {messages.map((msg, idx) => (
                            <ChatMessage
                              key={idx}
                              style={{
                                textAlign:
                                  msg.from === "user" ? "right" : "left",
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor:
                                    msg.from === "user" ? "#7620ff" : "#f3f4f6",
                                  color:
                                    msg.from === "user" ? "#fff" : "#374151",
                                  padding: "4px 12px",
                                  borderRadius: "10px",
                                  letterSpacing: "1px",
                                  fontSize: "16px",
                                  display: "inline-block",
                                  margin: "4px 0",
                                  maxWidth: "500px",
                                  overflow: "hidden",
                                }}
                              >
                                <p
                                  style={{
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {msg.text}
                                </p>
                              </div>
                            </ChatMessage>
                          ))}

                          {loading && (
                            <ChatMessage style={{ textAlign: "left" }}>
                              <div
                                style={{
                                  backgroundColor: "#f3f4f6",
                                  color: "#374151",
                                  padding: "4px 20px",
                                  borderRadius: "10px",
                                  fontSize: "16px",
                                  display: "inline-block",
                                }}
                              >
                                <p>Loading...</p>
                              </div>
                            </ChatMessage>
                          )}
                        </ChatBody>

                        <ChatInputContainer>
                          <ChatInput
                            id="text"
                            name="text"
                            type="text"
                            placeholder="Write a text here..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleSubmit();
                            }}
                          />
                          <SendButton
                            type="submit"
                            // onClick={() => handleSend(input)}
                            disabled={input === "" ? true : false}
                          >
                            <LuSendHorizontal fontSize={18} />
                          </SendButton>
                        </ChatInputContainer>
                      </ChatWindow>
                    </ChatPreview>
                  </div>
                </DemoWrapper>
              </Form>
            )}
          </Formik>
        </HeroContainer>
      </Wrapper>

      <DemoSampleWrapper className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Features</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <DemoSampleWrapperDiv>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuKeyboard fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Resume Parsing and Keyword Analysis
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Automatically extracts and analyzes resume content to identify
                key information including skills, experience, and
                qualifications.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <LuAlignHorizontalJustifyCenter fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Job Description Alignment
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Upload job descriptions to compare against your resume,
                Identifies gaps between your resume content and job
                requirements.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <GoCodescanCheckmark fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Quantifiable Achievement Scanner
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Identifies and highlights quantifiable achievements in your
                resume.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdOutlineFormatSize fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Resume Formatting Feedback
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Many resumes fail ATS scans due to formatting errors. Our tool
                checks for file type compatibility.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdApproval fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Language & Tone Optimization
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Avoid passive language and overused buzzwords. The analyzer
                reviews your sentence structure, verb usage, and tone—helping
                you present yourself with clarity and authority.
              </DemoFeatureDesc>
            </FeatureWrapper>
            <FeatureWrapper className="whiteBg radius8 shadow">
              <DemoFeatureDiv>
                <DemoFeatureIcon>
                  <MdOutlineTipsAndUpdates fontSize={26} />
                </DemoFeatureIcon>
                <DemoFeatureTitle className="font20 extraBold">
                  Overall ATS Score & Improvement Tips
                </DemoFeatureTitle>
              </DemoFeatureDiv>
              <DemoFeatureDesc className="font13">
                Receive a detailed breakdown of your ATS compatibility score
                with personalized suggestions.
              </DemoFeatureDesc>
            </FeatureWrapper>
          </DemoSampleWrapperDiv>
        </div>
      </DemoSampleWrapper>

      {/* Testimonial */}
      <Testimonial />
    </>
  );
};

const Wrapper = styled.section`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 110px 30px 0px 30px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const HeroContainer = styled.section`
  background-color: #f9fafb;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 32px;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
  min-width: 300px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
`;

const Description = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 2;
`;

const DemoSampleWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const DemoSampleWrapperDiv = styled.div`
  width: 100%;
  max-width: 1220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const FeatureWrapper = styled.div`
  width: 350px;
  height: 220px;
  text-align: left;
  padding: 20px 30px;
  margin: 30px 0px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: scale(1.05) translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  }
`;

const DemoFeatureDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DemoFeatureIcon = styled.div`
  width: 30%;
  width: 60px;
  height: 60px;
  background-color: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DemoFeatureTitle = styled.h3`
  width: 70%;
  padding: 10px 15px;
`;

const DemoFeatureDesc = styled.p`
  padding: 10px 0px;
`;

const DemoWrapper = styled.div`
  width: 100%;
`;

const DemoDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;

const DescSectionDiv = styled.div`
  width: 45%;
  height: auto;
  min-height: 400px;
  max-height: 600px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 12px;
  border-top: 12px solid #7620ff;
  padding: 32px;
  @media (max-width: 860px) {
    width: 100%;
  }
`;
const ResumeSectionDiv = styled.div`
  width: 45%;
  height: auto;
  min-height: 400px;
  max-height: 600px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 12px;
  border-top: 12px solid #7620ff;
  padding: 32px;
  @media (max-width: 860px) {
    width: 100%;
  }
`;

const CardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TextAreaWrapper = styled.div`
  width: 100%;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 240px;
  max-height: 300px;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #7620ff;
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.1);
  }

  &::placeholder {
    color: #9e9e9e;
  }
`;

const HiddenFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: -1;
`;

const ErrorMessageStyled = styled(ErrorMessage)`
  color: #ff3860;
  font-size: 12px;
  margin-top: 5px;
  font-weight: 500;
`;

const ChatPreview = styled.div`
  flex: 1;
  min-width: 300px;

  @media (max-width: 1024px) {
    min-width: 100%;
  }
`;

const ChatWindow = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const ChatHeader = styled.div`
  background-color: #7620ff;
  color: white;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const BotInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const BotName = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

// Keyframes for 360deg rotation
const rotate360 = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const RefreshIcon = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ rotating }) =>
    rotating &&
    css`
      animation: ${rotate360} 1s linear;
    `}
`;

const ChatBody = styled.div`
  padding: 24px;
  height: 450px;
  display: flex;
  flex-direction: column;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 5px;
    height: 200px;
  }
  ::-webkit-scrollbar-thumb {
    background: #7620ff;
    border-radius: 5px;
  }
`;

const ChatMessage = styled.div`
  text-align: center;
  color: #6b7280;
  margin-bottom: 10px;
`;

const ChatInputContainer = styled.div`
  margin: 0px 24px 24px 24px;
  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-top: auto;
`;

const ChatInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: none;
  outline: none;
  font-size: 14px;
  color: #374151;

  &::placeholder {
    color: #9ca3af;
  }
`;

const SendButton = styled.button`
  background-color: #7620ff;
  color: white;
  border: none;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const UploadButton = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  box-shadow: 0 4px 6px rgba(118, 32, 255, 0.2);

  &:hover {
    background-color: #6010e2;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #b794f6;
    cursor: not-allowed;
    transform: none;
  }
`;

// const ErrorMessage = styled.div`
//   color: #d93025;
//   font-size: 14px;
//   margin-top: 5px;
// `;

const FileListContainer = styled.div`
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
`;

const FileListTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
`;

const FileList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
`;

const FileItem = styled.li`
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

const FileIcon = styled.span`
  margin-right: 10px;
  font-size: 20px;
`;

const FileName = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #d93025;
  cursor: pointer;
  font-size: 16px;
  padding: 5px;

  &:hover {
    color: #a52714;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

const ResumeOptionDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px 0px;
`;

const ResumeOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  width: 100%;
`;

const ResumeOption = styled.div`
  width: 30%;
  text-align: center;
`;

const ResumeTitle = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  color: #333;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;
`;

// Try button styling
const TryButton = styled.button`
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: #6010e2;
  }
`;

export default ResumeAnalyseChatBotAgent;
